import { useMemo } from 'react';
import { ActionState } from '@colonist/game-states';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useCurrentStateValidator } from '../../store/selectors/useCurrentStateValidator.ts';
import { EnumUtils } from '@colonist/utils';
import { CurrentStateMessageUtils } from '../UIGameCurrentStatus/CurrentStateMessageUtils.ts';
export const usePlayerStatus = (playerColor)=>{
    const currentStateValidator = useCurrentStateValidator();
    const myPlayerColor = useGameStore((state)=>state.myColor);
    const playerActionState = currentStateValidator.getPlayerActionState(playerColor);
    const isMyPlayer = playerColor === myPlayerColor;
    return useMemo(()=>{
        const perspectiveKey = isMyPlayer ? 'self' : 'other';
        const effectiveActionState = !isMyPlayer && CurrentStateMessageUtils.isActionStateHiddenFromOpponents(playerActionState) ? ActionState.None : playerActionState;
        const actionStateKey = EnumUtils.getEnumKey(effectiveActionState, ActionState);
        const translationKey = `strings:game.playerInformation.playerStatus.${actionStateKey}.${perspectiveKey}`;
        return {
            key: translationKey
        };
    }, [
        playerActionState,
        isMyPlayer
    ]);
};
